function SwiperNavigation({
  handlePrev,
  handleNext,
  theme = "light",
  withAnim = "",
}) {
  return (
    <div className={`swiper-navigation ${theme} ${withAnim}`}>
      <button className="prev-btn" onClick={() => handlePrev()}>
        <i className="cxi-long-arrow-left" />
      </button>
      <button className="next-btn" onClick={() => handleNext()}>
        <i className="cxi-long-arrow-right" />
      </button>
    </div>
  )
}

export default SwiperNavigation
